/** Mini store IndexedDB per tenere i video in attesa di invio anche dopo la chiusura dell'app. */
const DB_NAME = "kilolava";
const STORE = "pending_files";

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export const idbPut = (key, blob) => tx("readwrite", (s) => s.put(blob, key));
export const idbGet = (key) => tx("readonly", (s) => s.get(key));
export const idbDel = (key) => tx("readwrite", (s) => s.delete(key));
